var _style, _path, _polygon, _path2, _polygon2, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _polygon3, _polygon4, _path16, _polygon5, _path17, _path18, _path19, _path20, _circle, _path21, _path22, _path23, _path24, _path25, _ellipse2, _path26, _path27, _path28, _polygon6, _path29, _path30, _path31, _path32, _path33, _circle2, _path34, _path35, _path36, _path37, _ellipse3, _ellipse4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlider2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6ee8617-cc99-4eb9-a93b-e1a7e83c9724",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "538 -305.1 1000 710",
    style: {
      enableBackground: "new 538 -305.1 1000 710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{opacity:0.1;enable-background:new    ;}\n\t.st2{fill:#3F3D56;}\n\t.st3{fill:#E03997;}\n\t.st4{fill:#A8A8A8;}\n\t.st5{opacity:0.2;enable-background:new    ;}\n\t.st6{fill:#FFB9B9;}\n\t.st7{fill:#D0CDE1;}\n\t.st8{fill:#2F2E41;}\n\t.st9{fill:#A0616A;}\n\t.st10{fill:#575A89;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "code typing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1359-18.9c-39.3-154.4-174.9-265.8-334.1-270.3c-84.2-2.4-172.7,25.6-237.2,123.2 C672.4,8.7,794.7,129.4,880,186.7c41.2,27.8,78.3,61.1,110.3,99.2c57.6,68.4,168.5,153.3,300.5,20.2 C1386.5,209.6,1385.1,83.9,1359-18.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1182.1,127.2 1262.9,46.7 1182.1,-33.8 1206.8,-58.4 1312.2,46.7 1206.8,151.8 1182.1,127.2 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M951.5,52.4h32.8V19.6h-32.8V52.4z M1116.3,19.6h-32.8v32.8h32.8V19.6z M1017.5,52.4h32.8V19.6h-32.8V52.4z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "907,126.4 826.1,45.9 906.9,-34.7 882.3,-59.2 777,45.9 882.4,150.9 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1484.6,328.3c0,13.6-199.9,60.7-446.6,60.7s-446.6-47.1-446.6-60.7c0-13.6,199.9,11.5,446.6,11.5 S1484.6,314.7,1484.6,328.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1484.6,328.3c0,13.6-199.9,60.7-446.6,60.7s-446.6-47.1-446.6-60.7c0-13.6,199.9,11.5,446.6,11.5 S1484.6,314.7,1484.6,328.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1038,
    cy: 328.3,
    rx: 446.6,
    ry: 24.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1110.8,209.8c0,52.5,33,95.1,73.7,95.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1184.5,304.8c0-53.1,36.8-96.1,82.3-96.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1137.5,214.5c0,49.9,21,90.3,47,90.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1184.5,304.8c0-67.9,42.5-122.8,95.1-122.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1169,305.5c0,0,10.5-0.3,13.6-2.6s16.1-4.9,16.9-1.3s15.7,17.9,3.9,18s-27.4-1.8-30.6-3.8 C1169.7,313.9,1169,305.5,1169,305.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1203.6,318.4c-11.8,0.1-27.4-1.8-30.6-3.8c-2.4-1.5-3.3-6.7-3.7-9.1c-0.2,0-0.3,0-0.3,0s0.7,8.4,3.8,10.3 c3.1,1.9,18.8,3.8,30.6,3.8c3.4,0,4.6-1.2,4.5-3C1207.4,317.7,1206.1,318.3,1203.6,318.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1301.9,25c0,0-25.3-19.2-27.2-12.2c-1.9,7,18.5,23,18.5,23L1301.9,25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1301.9,25c0,0-25.3-19.2-27.2-12.2c-1.9,7,18.5,23,18.5,23L1301.9,25z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.4-35.8c0,0-30.1,53.7-30.7,61.4c-0.6,7.7-0.6,8.3-3.2,7.7c-2.6-0.6-37.7-4.5-40.9-3.2 c-3.2,1.3-9.6-7.7-9.6-7.7s-12.1,12.1-9.6,14.7c2.6,2.6,10.2,3.8,11.5,7c1.3,3.2,3.2,6.4,9,5.8c5.8-0.6,44.8,10.2,49.9,8.3 c5.1-1.9,6.4-5.1,9-5.1c2.6,0,7.7-2.6,7.7-3.2c0-0.6,17.9-34.5,17.9-34.5S1417.3-30.7,1385.4-35.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1385.4-35.8c0,0-30.1,53.7-30.7,61.4c-0.6,7.7-0.6,8.3-3.2,7.7c-2.6-0.6-37.7-4.5-40.9-3.2 c-3.2,1.3-9.6-7.7-9.6-7.7s-12.1,12.1-9.6,14.7c2.6,2.6,10.2,3.8,11.5,7c1.3,3.2,3.2,6.4,9,5.8c5.8-0.6,44.8,10.2,49.9,8.3 c5.1-1.9,6.4-5.1,9-5.1c2.6,0,7.7-2.6,7.7-3.2c0-0.6,17.9-34.5,17.9-34.5S1417.3-30.7,1385.4-35.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1341.8-71.2c-0.3,3.4-0.2,6.8,0.2,10.2c1,7.3,4.4,15,1.2,21.9c-1.2,2.5-3.1,4.7-4.2,7.2 c-2.3,5.3-0.2,11.2-0.5,16.9c-0.4,7.3-5.1,14.4-12.2,18.4c12.1,0.4,23.6-5.6,31.3-13.8c7.6-8.2,11.9-18.3,15.1-28.4 c1.6-4.8,2.7-9.7,3.1-14.7c0.3-2.9-0.1-5.8-1-8.5c-1.1-2.7-2.6-5.2-4.4-7.5c-1.9-2.7-3.9-5.4-6.7-7.4c-3.5-2.5-10.2-4.9-14.8-4.6 C1343.2-81.1,1342-75.1,1341.8-71.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1360.4-51.1c0,0,7,24.9,1.3,32c-5.8,7,34.5-3.2,34.5-3.2S1376.4-42.2,1386-55L1360.4-51.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1360.4-51.1c0,0,7,24.9,1.3,32c-5.8,7,34.5-3.2,34.5-3.2S1376.4-42.2,1386-55L1360.4-51.1z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1182.1,111.6 1262.9,31.1 1182.1,-49.4 1206.8,-74 1312.2,31.1 1206.8,136.2 1182.1,111.6 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1337.4,281.4 1337.4,299.9 1347,311.5 1355.3,307.6 1352.8,280.8 "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1341.3,298.7c0,0-2.6-9-7-2.6c-4.5,6.4-9,20.5-11.5,21.1s-20.5,20.5-2.6,20.5c17.9,0,23.7-8.3,23.7-8.3 s17.9-7,17.9-8.3c0-1.3-2.6-24.9-3.8-24.9c-1.3,0-1.9,4.5-5.1,4.5C1349.6,300.6,1341.3,298.7,1341.3,298.7z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1380.3,284.6 1379.6,301.9 1395,308.3 1395,283.3 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1396.9,301.9c0,0-8.3-9-12.8-7c-2.2,0.9-4.4,2-6.4,3.2c0,0-2.6,8.3-3.8,15.3c-1.3,7-1.9,10.2-3.2,12.8 s-2.6,12.1,10.2,13.4s16.6-5.8,16.6-5.8l3.2-16.6C1400.7,317.2,1399.4,301.9,1396.9,301.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1345.7,100.4c0,0-18.5,41.6-16,79.3c0,0-6.4,14.7-2.6,37.7s9,69.1,9,69.1s17.3,1.9,18.5-1.3 c0,0,1.3-32,2.6-33.3c1.3-1.3-0.6-30.7-2.6-36.4c-1.9-5.8,17.9-62.7,17.9-62.7l-5.1-71L1345.7,100.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1345.7,100.4c0,0-18.5,41.6-16,79.3c0,0-6.4,14.7-2.6,37.7s9,69.1,9,69.1s17.3,1.9,18.5-1.3 c0,0,1.3-32,2.6-33.3c1.3-1.3-0.6-30.7-2.6-36.4c-1.9-5.8,17.9-62.7,17.9-62.7l-5.1-71L1345.7,100.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1340.6,97.9l12.1,26.2c0,0,5.8,59.5,9,67.1c0,0,1.3,21.7,7,28.8c5.8,7,10.2,69.1,10.2,69.1s16,4.5,17.3,0 c1.3-4.5,5.1-35.2,5.1-35.2s1.3-26.2-5.8-43.5s8.3-79.3,8.3-79.3s16-30.1-7-54.4L1340.6,97.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1374.5,
    cy: -69.7,
    r: 26.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1398.8-30c0,0-27.5,0-31.3,3.2c-2,1.9-5.1,1.9-7,0c0,0-9.6,0.6-12.1,8.3s-10.2,17.9-10.2,17.9 s-11.5,8.3-5.1,30.1c6.4,21.7,1.3,56.9,1.3,56.9s-5.1,7.7,0,10.9c5.1,3.2,7,4.5,6.4,7c-0.6,2.6,58.2-21.1,58.2-25.6 c0-4.5-1.3-8.3,0-10.2c1.3-1.9,2.6-5.1,1.3-8.3s1.3-3.8,0.6-7c-0.6-3.2,3.2-26.9,5.8-37.1S1408.4-29.4,1398.8-30z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1301.9,32.7c0,0-25.3-19.2-27.2-12.2c-1.9,7,18.5,23,18.5,23L1301.9,32.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.4-26.8c0,0-30.1,53.7-30.7,61.4c-0.6,7.7-0.6,8.3-3.2,7.7c-2.6-0.6-37.7-4.5-40.9-3.2 c-3.2,1.3-9.6-7.7-9.6-7.7s-12.1,12.1-9.6,14.7c2.6,2.6,10.2,3.8,11.5,7s3.2,6.4,9,5.8c5.8-0.6,44.8,10.2,49.9,8.3 c5.1-1.9,6.4-5.1,9-5.1c2.6,0,7.7-2.6,7.7-3.2s17.9-34.5,17.9-34.5S1417.3-21.7,1385.4-26.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1361.5-52.9c-0.4-2.6-1.7-5-2.4-7.5c-1.1-4.1-0.4-8.5,1.8-12.1c3.8-6.1,11.1-8.8,16.3-13.7 c0.1,2.5,1.9,4.7,3.8,6.3c1.9,1.6,4.2,2.9,5.8,4.9c1.6,2,2.7,4.4,3.4,6.8c1,2.9,1.5,5.9,1.3,9c-0.1,3.1-1.6,6-3.9,8 c-1.9,1.5-4.6,2.4-5.5,4.6c-0.4,1.1-0.5,2.3-0.3,3.5c0.4,7,0.8,14.2-0.8,21c-1.7,6.9-5.7,13.5-12.1,16.5c5.2,0.4,10.6,0.7,15.6-0.6 s9.9-4.6,11.7-9.6c0.9-2.4,0.9-5.1,2.2-7.4c3.1-5.8,11.7-6,15.9-11c1.7-2,2.5-4.6,3.1-7.1c3.6-15,1.1-30.9-4.4-45.3 c-1.9-5-4.2-10-8.2-13.5c-3.4-3-7.7-4.6-12-6c-6.3-2-12.7-3.7-19.3-3.9c-2.9-0.2-5.7,0.2-8.5,1c-2.7,1-5.2,2.4-7.5,4.3 c-10.3,8-17.4,20.9-16.4,33.9c0.6,7.9,3.9,15.4,8.2,22c1.5,2.3,5.1,7.3,8.4,5.8C1360.6-44.4,1361.9-50.1,1361.5-52.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M951.5,36.8h32.8V4h-32.8V36.8z M1116.3,4h-32.8v32.8h32.8V4z M1017.5,36.8h32.8V4h-32.8V36.8z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 760.7,
    cy: -115.4,
    rx: 27.6,
    ry: 21.6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M765.4,33c0,0,24.9,1.7,29.3-1.7c4.4-3.3,23.2,4.4,24.9,8.8s-26.5,5-30.9,5c-4.4,0-25.4,6.6-25.4,6.6L765.4,33z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M714.2,290.4c0,0-11.6,29.2-5.5,32.7c6,3.5,69.5,1,69.5,1s10.6-6.5-1.5-11.1c0,0-10.1-0.5-16.6-4.5 s-14.1-11.6-14.1-11.6s-0.5-11.1-4.5-8.6c-2.4,1.6-4.1,4.2-4.5,7.1L714.2,290.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M714.2,290.4c0,0-11.6,29.2-5.5,32.7c6,3.5,69.5,1,69.5,1s10.6-6.5-1.5-11.1c0,0-10.1-0.5-16.6-4.5 s-14.1-11.6-14.1-11.6s-0.5-11.1-4.5-8.6c-2.4,1.6-4.1,4.2-4.5,7.1L714.2,290.4z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "907,110.8 826.1,30.3 906.9,-50.3 882.3,-74.8 777,30.3 882.4,135.3 "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M696.3,299.3c0,0-12.7,32-6.1,35.9c6.6,3.9,76.3,1.1,76.3,1.1s11.6-7.2-1.7-12.2c0,0-11.1-0.6-18.2-5 s-15.5-12.7-15.5-12.7s-0.6-12.2-5-9.4c-2.7,1.8-4.5,4.6-5,7.7L696.3,299.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M761.5,96l-7.7,69.6c0,0-2.8,33.2-11.1,40.3c0,0,0,10.5-2.8,13.8l-3.9,43.7c0,0,5.5,16,5,18.8 s2.2,11.6,1.7,12.7c-0.6,1.1-26.5,0-26.5,0l5.5-89l17.1-123.8L761.5,96z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M761.5,96l-7.7,69.6c0,0-2.8,33.2-11.1,40.3c0,0,0,10.5-2.8,13.8l-3.9,43.7c0,0,5.5,16,5,18.8 s2.2,11.6,1.7,12.7c-0.6,1.1-26.5,0-26.5,0l5.5-89l17.1-123.8L761.5,96z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M747.7,93.7c0,0-6.1,56.9-8.8,69.1c-1.7,8-2.8,16.1-3.3,24.3c0,0-0.6,17.7-5.5,22.7c-2.9,2.9-4.5,6.9-4.4,11.1 c0,0-5,55.8-2.2,62.4c2.8,6.6,5.5,12.2,2.8,16.6c-2.8,4.4-33.2,4.4-33.2,1.1c0-3.3,0-6.1-1.7-7.7c-1.7-1.7,0-12.2,0-12.2 s-6.6-49.2-0.6-63.5c6.1-14.4,8.8-53.6,8.8-53.6s-4.4-44.8-9.9-51.9c-5.5-7.2,1.1-32.6,1.1-32.6L747.7,93.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M732.2-83c0.6,1.5,2.2,2.3,3.6,3c8.1,4.5,14.9,10.9,21.6,17.4c-1.7-5.7-1.3-11.7,1-17.1 c0.8-1.8,1.8-3.8,1.3-5.8c-0.4-1.4-1.6-2.4-2.8-3.4c-2.7-2.1-5.6-4.1-8.5-5.8c-2.1-1.2-6.3-4.5-8.7-4.2c-0.1,3.2-0.2,6.1-1.6,9.1 C737.6-89.1,732.4-82.4,732.2-83z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 760.4,
    cy: -98.5,
    r: 22.7
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M761.5-44.9c0,0,3.9-19.3-7.2-26c-11.1-6.6-23.8-14.4-23.8-14.4s-3.9-0.6-5.5,7.7c0,0-31.5,6.1-34.8,35.9 s2.2,73.5,2.2,73.5s-5,38.1-11.1,58.6c0,0-5,4.4,17.1-2.2c22.1-6.6,60.8,18.8,60.8,18.8s3.9-3.9,3.9-6.6c0-2.8,4.4-18.8,4.4-18.8 s3.9-68,5.5-75.7C774.8-1.8,766.5-43.8,761.5-44.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M755.1-96.2c1.4-0.8,2.9-1.2,4.4-1.2c1.6,0,3.1-0.5,4.4-1.3c2.1-1.6,2.3-4.8,3.9-7c2.3-3.2,6.8-3.6,10.7-3.4 c2.4,0.1,5,0.2,7-1.1c2.1-1.3,3-3.8,3.7-6.2c0.8-2.8,1.4-6.2-0.7-8.2c-1.4-1.4-3.7-1.7-5.2-3c-1.6-1.3-2.3-3.4-3.2-5.3 c-1-2.3-2.6-4.3-4.6-5.8c-3-2.1-6.8-2.5-10.4-2.5c-3.6,0-7.2,0.5-10.8,0.1c-2.9-0.4-5.9-1.3-8.8-0.9c-3.7,0.6-6.8,3.4-8.7,6.7 c-1.8,3.3-2.6,7.1-3.4,10.7l-2.1,10c-0.6,3.1-1.3,6.3-0.8,9.5c1,6.5,6.8,11.7,7.2,18.3c0.8-3.7,3.3-6.8,6.8-8.1 c0.4-0.2,0.9-0.3,1.4-0.2c0.6,0.2,0.9,0.8,1.3,1.2c0.9,1.3,3.9,3.2,5.6,2.3C754.3-92.4,753.2-94.9,755.1-96.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M698,7c0,0-3.9,24.3,12.2,22.1c0,0,8.3-1.1,9.4,0c1.1,1.1,42-6.1,47.5-12.2c0,0,6.6-2.2,9.9,1.1 s36.5,6.6,26.5-3.3c-9.9-9.9-25.4-12.2-25.4-12.2l-21,1.1c0,0-11.1,3.3-17.7,0S714,1.5,714,1.5L698,7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M720.6-69.8c0,0-24.9,2.8-24.9,38.7v45.9c0,0,13.8-6.1,16.6-5.5c2.8,0.6,13.8-7.2,13.8-7.2 s12.7-29.8,11.6-38.1C736.7-44.4,737.2-68.7,720.6-69.8z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 760.4,
    cy: -112.6,
    rx: 21.3,
    ry: 11.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 740.5,
    cy: -110.7,
    rx: 7.5,
    ry: 18.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider2);
export default __webpack_public_path__ + "static/media/slider2.de9232fe899901ba93c430a1942239a7.svg";
export { ForwardRef as ReactComponent };